"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(key) {
    if (typeof TYPO3 === 'object' && typeof TYPO3.lang === 'object' && typeof TYPO3.lang[key] === 'string') {
        return TYPO3.lang[key];
    }
    return key;
}
exports.default = default_1;
